export const SansFont = {
    smufl: false,
    name: 'SANS',
    spacing: 50,
    Description: 'Built-in sans-serif font',
    bold: true,
    italic: true,
    monospaced: false,
    serifs: false,
    glyphs: {
        '0': {
            xMin: 85,
            xMax: 1041,
            yMin: -25,
            yMax: 1472,
            ha: 1497,
            leftSideBearing: 85,
            advanceWidth: 1139,
        },
        '1': {
            xMin: 223,
            xMax: 763,
            yMin: 0,
            yMax: 1472,
            ha: 1472,
            leftSideBearing: 223,
            advanceWidth: 1139,
        },
        '2': {
            xMin: 61.840001123045234,
            xMax: 1031,
            yMin: 0,
            yMax: 1472,
            ha: 1472,
            leftSideBearing: 61,
            advanceWidth: 1139,
        },
        '3': {
            xMin: 86,
            xMax: 1046,
            yMin: -26,
            yMax: 1472,
            ha: 1498,
            leftSideBearing: 86,
            advanceWidth: 1139,
        },
        '4': {
            xMin: 26,
            xMax: 1040,
            yMin: 0,
            yMax: 1466,
            ha: 1466,
            leftSideBearing: 26,
            advanceWidth: 1139,
        },
        '5': {
            xMin: 85,
            xMax: 1057,
            yMin: -25,
            yMax: 1446,
            ha: 1471,
            leftSideBearing: 85,
            advanceWidth: 1139,
        },
        '6': {
            xMin: 77,
            xMax: 1045,
            yMin: -25,
            yMax: 1472,
            ha: 1497,
            leftSideBearing: 77,
            advanceWidth: 1139,
        },
        '7': {
            xMin: 97,
            xMax: 1046,
            yMin: 0,
            yMax: 1447,
            ha: 1447,
            leftSideBearing: 97,
            advanceWidth: 1139,
        },
        '8': {
            xMin: 83,
            xMax: 1049,
            yMin: -25,
            yMax: 1472,
            ha: 1497,
            leftSideBearing: 83,
            advanceWidth: 1139,
        },
        '9': {
            xMin: 85,
            xMax: 1049,
            yMin: -25,
            yMax: 1472,
            ha: 1497,
            leftSideBearing: 85,
            advanceWidth: 1139,
        },
        ' ': {
            xMin: 0,
            xMax: 0,
            yMin: 0,
            yMax: 0,
            ha: 0,
            leftSideBearing: 0,
            advanceWidth: 569,
        },
        '!': {
            xMin: 176,
            xMax: 399,
            yMin: 0,
            yMax: 1466,
            ha: 1466,
            leftSideBearing: 176,
            advanceWidth: 569,
        },
        '"': {
            xMin: 94,
            xMax: 631,
            yMin: 947,
            yMax: 1466,
            ha: 519,
            leftSideBearing: 94,
            advanceWidth: 727,
        },
        '#': {
            xMin: 21,
            xMax: 1113,
            yMin: -25,
            yMax: 1491,
            ha: 1516,
            leftSideBearing: 21,
            advanceWidth: 1139,
        },
        $: {
            xMin: 73,
            xMax: 1043,
            yMin: -211,
            yMax: 1601,
            ha: 1812,
            leftSideBearing: 73,
            advanceWidth: 1139,
        },
        '%': {
            xMin: 119,
            xMax: 1695,
            yMin: -54,
            yMax: 1491,
            ha: 1545,
            leftSideBearing: 119,
            advanceWidth: 1821,
        },
        '&': {
            xMin: 88,
            xMax: 1319,
            yMin: -34,
            yMax: 1491,
            ha: 1525,
            leftSideBearing: 88,
            advanceWidth: 1366,
        },
        "'": {
            xMin: 90,
            xMax: 295,
            yMin: 947,
            yMax: 1466,
            ha: 519,
            leftSideBearing: 90,
            advanceWidth: 391,
        },
        '(': {
            xMin: 124,
            xMax: 608,
            yMin: -431,
            yMax: 1491,
            ha: 1922,
            leftSideBearing: 124,
            advanceWidth: 682,
        },
        ')': {
            xMin: 124,
            xMax: 608,
            yMin: -431,
            yMax: 1491,
            ha: 1922,
            leftSideBearing: 124,
            advanceWidth: 682,
        },
        '*': {
            xMin: 64,
            xMax: 725,
            yMin: 867,
            yMax: 1491,
            ha: 624,
            leftSideBearing: 64,
            advanceWidth: 797,
        },
        '+': {
            xMin: 114,
            xMax: 1082,
            yMin: 237,
            yMax: 1206,
            ha: 969,
            leftSideBearing: 114,
            advanceWidth: 1196,
        },
        ',': {
            xMin: 170,
            xMax: 387,
            yMin: -290,
            yMax: 205,
            ha: 495,
            leftSideBearing: 170,
            advanceWidth: 569,
        },
        '-': {
            xMin: 65,
            xMax: 618,
            yMin: 440,
            yMax: 621,
            ha: 181,
            leftSideBearing: 65,
            advanceWidth: 682,
        },
        '.': {
            xMin: 186,
            xMax: 391,
            yMin: 0,
            yMax: 205,
            ha: 205,
            leftSideBearing: 186,
            advanceWidth: 569,
        },
        '/': {
            xMin: 0,
            xMax: 569,
            yMin: -25,
            yMax: 1491,
            ha: 1516,
            leftSideBearing: 0,
            advanceWidth: 569,
        },
        ':': {
            xMin: 185,
            xMax: 390,
            yMin: 0,
            yMax: 1062,
            ha: 1062,
            leftSideBearing: 185,
            advanceWidth: 569,
        },
        ';': {
            xMin: 170,
            xMax: 387,
            yMin: -290,
            yMax: 1062,
            ha: 1352,
            leftSideBearing: 170,
            advanceWidth: 569,
        },
        '<': {
            xMin: 112,
            xMax: 1083,
            yMin: 226,
            yMax: 1219,
            ha: 993,
            leftSideBearing: 112,
            advanceWidth: 1196,
        },
        '=': {
            xMin: 114,
            xMax: 1082,
            yMin: 417,
            yMax: 1030,
            ha: 613,
            leftSideBearing: 114,
            advanceWidth: 1196,
        },
        '>': {
            xMin: 112,
            xMax: 1083,
            yMin: 226,
            yMax: 1219,
            ha: 993,
            leftSideBearing: 112,
            advanceWidth: 1196,
        },
        '?': {
            xMin: 90,
            xMax: 1036,
            yMin: 0,
            yMax: 1491,
            ha: 1491,
            leftSideBearing: 90,
            advanceWidth: 1139,
        },
        '@': {
            xMin: 111,
            xMax: 2005,
            yMin: -431,
            yMax: 1493,
            ha: 1924,
            leftSideBearing: 111,
            advanceWidth: 2079,
        },
        A: {
            xMin: -3,
            xMax: 1369,
            yMin: 0,
            yMax: 1466,
            ha: 1466,
            leftSideBearing: -3,
            advanceWidth: 1366,
        },
        B: {
            xMin: 150,
            xMax: 1257,
            yMin: 0,
            yMax: 1466,
            ha: 1466,
            leftSideBearing: 150,
            advanceWidth: 1366,
        },
        C: {
            xMin: 102,
            xMax: 1398,
            yMin: -25,
            yMax: 1491,
            ha: 1516,
            leftSideBearing: 102,
            advanceWidth: 1479,
        },
        D: {
            xMin: 158,
            xMax: 1370,
            yMin: 0,
            yMax: 1466,
            ha: 1466,
            leftSideBearing: 158,
            advanceWidth: 1479,
        },
        E: {
            xMin: 162,
            xMax: 1256,
            yMin: 0,
            yMax: 1466,
            ha: 1466,
            leftSideBearing: 162,
            advanceWidth: 1366,
        },
        F: {
            xMin: 168,
            xMax: 1157,
            yMin: 0,
            yMax: 1466,
            ha: 1466,
            leftSideBearing: 168,
            advanceWidth: 1251,
        },
        G: {
            xMin: 109,
            xMax: 1465,
            yMin: -25,
            yMax: 1491,
            ha: 1516,
            leftSideBearing: 109,
            advanceWidth: 1593,
        },
        H: {
            xMin: 164,
            xMax: 1314,
            yMin: 0,
            yMax: 1466,
            ha: 1466,
            leftSideBearing: 164,
            advanceWidth: 1479,
        },
        I: {
            xMin: 191,
            xMax: 385,
            yMin: 0,
            yMax: 1466,
            ha: 1466,
            leftSideBearing: 191,
            advanceWidth: 569,
        },
        J: {
            xMin: 58.84976474807333,
            xMax: 865,
            yMin: -25,
            yMax: 1466,
            ha: 1491,
            leftSideBearing: 58,
            advanceWidth: 1024,
        },
        K: {
            xMin: 150,
            xMax: 1362,
            yMin: 0,
            yMax: 1466,
            ha: 1466,
            leftSideBearing: 150,
            advanceWidth: 1366,
        },
        L: {
            xMin: 150,
            xMax: 1066,
            yMin: 0,
            yMax: 1466,
            ha: 1466,
            leftSideBearing: 150,
            advanceWidth: 1139,
        },
        M: {
            xMin: 152,
            xMax: 1551,
            yMin: 0,
            yMax: 1466,
            ha: 1466,
            leftSideBearing: 152,
            advanceWidth: 1706,
        },
        N: {
            xMin: 156,
            xMax: 1311,
            yMin: 0,
            yMax: 1466,
            ha: 1466,
            leftSideBearing: 156,
            advanceWidth: 1479,
        },
        O: {
            xMin: 99,
            xMax: 1501,
            yMin: -25,
            yMax: 1492,
            ha: 1517,
            leftSideBearing: 99,
            advanceWidth: 1593,
        },
        P: {
            xMin: 158,
            xMax: 1277,
            yMin: 0,
            yMax: 1466,
            ha: 1466,
            leftSideBearing: 158,
            advanceWidth: 1366,
        },
        Q: {
            xMin: 88,
            xMax: 1518,
            yMin: -114,
            yMax: 1492,
            ha: 1606,
            leftSideBearing: 88,
            advanceWidth: 1593,
        },
        R: {
            xMin: 161,
            xMax: 1453,
            yMin: 0,
            yMax: 1466,
            ha: 1466,
            leftSideBearing: 161,
            advanceWidth: 1479,
        },
        S: {
            xMin: 92,
            xMax: 1259,
            yMin: -25,
            yMax: 1491,
            ha: 1516,
            leftSideBearing: 92,
            advanceWidth: 1366,
        },
        T: {
            xMin: 48,
            xMax: 1210,
            yMin: 0,
            yMax: 1466,
            ha: 1466,
            leftSideBearing: 48,
            advanceWidth: 1251,
        },
        U: {
            xMin: 161,
            xMax: 1314,
            yMin: -25,
            yMax: 1466,
            ha: 1491,
            leftSideBearing: 161,
            advanceWidth: 1479,
        },
        V: {
            xMin: 9,
            xMax: 1350,
            yMin: 0,
            yMax: 1466,
            ha: 1466,
            leftSideBearing: 9,
            advanceWidth: 1366,
        },
        W: {
            xMin: 25,
            xMax: 1910,
            yMin: 0,
            yMax: 1466,
            ha: 1466,
            leftSideBearing: 25,
            advanceWidth: 1933,
        },
        X: {
            xMin: 9,
            xMax: 1353,
            yMin: 0,
            yMax: 1466,
            ha: 1466,
            leftSideBearing: 9,
            advanceWidth: 1366,
        },
        Y: {
            xMin: 6,
            xMax: 1350,
            yMin: 0,
            yMax: 1466,
            ha: 1466,
            leftSideBearing: 6,
            advanceWidth: 1366,
        },
        Z: {
            xMin: 41,
            xMax: 1200,
            yMin: 0,
            yMax: 1466,
            ha: 1466,
            leftSideBearing: 41,
            advanceWidth: 1251,
        },
        '[': {
            xMin: 139,
            xMax: 536,
            yMin: -407,
            yMax: 1466,
            ha: 1873,
            leftSideBearing: 139,
            advanceWidth: 569,
        },
        '\\': {
            xMin: 0,
            xMax: 569,
            yMin: -25,
            yMax: 1491,
            ha: 1516,
            leftSideBearing: 0,
            advanceWidth: 569,
        },
        ']': {
            xMin: 39,
            xMax: 436,
            yMin: -407,
            yMax: 1466,
            ha: 1873,
            leftSideBearing: 39,
            advanceWidth: 569,
        },
        '^': {
            xMin: 54,
            xMax: 907,
            yMin: 690,
            yMax: 1491,
            ha: 801,
            leftSideBearing: 54,
            advanceWidth: 961,
        },
        _: {
            xMin: -31,
            xMax: 1162,
            yMin: -407,
            yMax: -277,
            ha: 130,
            leftSideBearing: -31,
            advanceWidth: 1139,
        },
        '`': {
            xMin: 89,
            xMax: 465,
            yMin: 1194,
            yMax: 1474,
            ha: 280,
            leftSideBearing: 89,
            advanceWidth: 682,
        },
        a: {
            xMin: 74,
            xMax: 1052,
            yMin: -24,
            yMax: 1086,
            ha: 1110,
            leftSideBearing: 74,
            advanceWidth: 1139,
        },
        b: {
            xMin: 134,
            xMax: 1055,
            yMin: -24,
            yMax: 1466,
            ha: 1490,
            leftSideBearing: 134,
            advanceWidth: 1139,
        },
        c: {
            xMin: 80,
            xMax: 1005,
            yMin: -24,
            yMax: 1086,
            ha: 1110,
            leftSideBearing: 80,
            advanceWidth: 1024,
        },
        d: {
            xMin: 70,
            xMax: 991,
            yMin: -24,
            yMax: 1466,
            ha: 1490,
            leftSideBearing: 70,
            advanceWidth: 1139,
        },
        e: {
            xMin: 75,
            xMax: 1054,
            yMin: -24,
            yMax: 1086,
            ha: 1110,
            leftSideBearing: 75,
            advanceWidth: 1139,
        },
        f: {
            xMin: 19,
            xMax: 640,
            yMin: 0,
            yMax: 1491,
            ha: 1491,
            leftSideBearing: 19,
            advanceWidth: 569,
        },
        g: {
            xMin: 66,
            xMax: 1002,
            yMin: -431,
            yMax: 1086,
            ha: 1517,
            leftSideBearing: 66,
            advanceWidth: 1139,
        },
        h: {
            xMin: 135,
            xMax: 1000,
            yMin: 0,
            yMax: 1466,
            ha: 1466,
            leftSideBearing: 135,
            advanceWidth: 1139,
        },
        i: {
            xMin: 136,
            xMax: 316,
            yMin: 0,
            yMax: 1466,
            ha: 1466,
            leftSideBearing: 136,
            advanceWidth: 455,
        },
        j: {
            xMin: -94,
            xMax: 314,
            yMin: -431,
            yMax: 1466,
            ha: 1897,
            leftSideBearing: -94,
            advanceWidth: 455,
        },
        k: {
            xMin: 136,
            xMax: 1016,
            yMin: 0,
            yMax: 1466,
            ha: 1466,
            leftSideBearing: 136,
            advanceWidth: 1024,
        },
        l: {
            xMin: 131,
            xMax: 311,
            yMin: 0,
            yMax: 1466,
            ha: 1466,
            leftSideBearing: 131,
            advanceWidth: 455,
        },
        m: {
            xMin: 135,
            xMax: 1574,
            yMin: 0,
            yMax: 1086,
            ha: 1086,
            leftSideBearing: 135,
            advanceWidth: 1706,
        },
        n: {
            xMin: 135,
            xMax: 998,
            yMin: 0,
            yMax: 1086,
            ha: 1086,
            leftSideBearing: 135,
            advanceWidth: 1139,
        },
        o: {
            xMin: 68,
            xMax: 1063,
            yMin: -24,
            yMax: 1086,
            ha: 1110,
            leftSideBearing: 68,
            advanceWidth: 1139,
        },
        p: {
            xMin: 135,
            xMax: 1057,
            yMin: -407,
            yMax: 1086,
            ha: 1493,
            leftSideBearing: 135,
            advanceWidth: 1139,
        },
        q: {
            xMin: 72,
            xMax: 992,
            yMin: -407,
            yMax: 1086,
            ha: 1493,
            leftSideBearing: 72,
            advanceWidth: 1139,
        },
        r: {
            xMin: 133,
            xMax: 710,
            yMin: 0,
            yMax: 1086,
            ha: 1086,
            leftSideBearing: 133,
            advanceWidth: 682,
        },
        s: {
            xMin: 63,
            xMax: 945,
            yMin: -24,
            yMax: 1086,
            ha: 1110,
            leftSideBearing: 63,
            advanceWidth: 1024,
        },
        t: {
            xMin: 36,
            xMax: 554,
            yMin: -14,
            yMax: 1433,
            ha: 1447,
            leftSideBearing: 36,
            advanceWidth: 569,
        },
        u: {
            xMin: 131,
            xMax: 992,
            yMin: -24,
            yMax: 1062,
            ha: 1086,
            leftSideBearing: 131,
            advanceWidth: 1139,
        },
        v: {
            xMin: 26,
            xMax: 1000,
            yMin: 0,
            yMax: 1062,
            ha: 1062,
            leftSideBearing: 26,
            advanceWidth: 1024,
        },
        w: {
            xMin: 6,
            xMax: 1463,
            yMin: 0,
            yMax: 1062,
            ha: 1062,
            leftSideBearing: 6,
            advanceWidth: 1479,
        },
        x: {
            xMin: 15,
            xMax: 1009,
            yMin: 0,
            yMax: 1062,
            ha: 1062,
            leftSideBearing: 15,
            advanceWidth: 1024,
        },
        y: {
            xMin: 33,
            xMax: 1006,
            yMin: -431,
            yMax: 1062,
            ha: 1493,
            leftSideBearing: 33,
            advanceWidth: 1024,
        },
        z: {
            xMin: 40,
            xMax: 980,
            yMin: 0,
            yMax: 1062,
            ha: 1062,
            leftSideBearing: 40,
            advanceWidth: 1024,
        },
        '{': {
            xMin: 57,
            xMax: 636,
            yMin: -431,
            yMax: 1491,
            ha: 1922,
            leftSideBearing: 57,
            advanceWidth: 684,
        },
        '|': {
            xMin: 188,
            xMax: 345,
            yMin: -431,
            yMax: 1491,
            ha: 1922,
            leftSideBearing: 188,
            advanceWidth: 532,
        },
        '}': {
            xMin: 47,
            xMax: 626,
            yMin: -431,
            yMax: 1491,
            ha: 1922,
            leftSideBearing: 47,
            advanceWidth: 684,
        },
        '~': {
            xMin: 87,
            xMax: 1110,
            yMin: 557,
            yMax: 885,
            ha: 328,
            leftSideBearing: 87,
            advanceWidth: 1196,
        },
    },
    fontFamily: 'sans-serif',
    resolution: 2048,
    generatedOn: '2020-10-18T18:48:11.823Z',
};
